var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonTrees64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4587 48.2048C19.8813 48.2057 17.2654 48.2141 16.9571 48.2046C12.3298 48.0628 9 42.5092 9 35.9185C9 25.9142 13.9124 17.563 18.5503 15.6043C19.1714 15.3197 19.8132 15.1699 20.4602 15.1699L20.4999 15.1706L20.5397 15.1699C21.1867 15.1699 21.8284 15.3197 22.4496 15.6047C27.0875 17.563 31.9999 25.9142 31.9999 35.9185C31.9999 42.5092 28.6701 48.0628 24.0428 48.2046C23.7345 48.2141 21.1186 48.2057 20.5412 48.2048H20.4587Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 34.1924V58.2209",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6267 44.2037L16.127 39.1978",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0914 48.2706C40.3956 48.2718 37.2431 48.2821 36.8715 48.2705C31.295 48.0955 27.2822 41.2419 27.2822 33.1083C27.2822 20.7622 33.2023 10.4562 38.7916 8.03901C39.5401 7.68778 40.3135 7.50293 41.0932 7.50293L41.1411 7.50379L41.189 7.50293C41.9688 7.50293 42.7421 7.68778 43.4907 8.03949C49.08 10.4562 55 20.7622 55 33.1083C55 41.2419 50.9872 48.0955 45.4108 48.2705C45.0391 48.2821 41.8866 48.2718 41.1908 48.2706H41.0914Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6357 27.3926V58.221",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.761 37.3376L37.3066 32.3652",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6357 41.3151L46.0903 36.3428",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonTrees64);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTrees64.c325d5b79d70943479cc7c6a841c6845.svg";
export { ForwardRef as ReactComponent };